import { useEffect, useRef, useState } from 'react';
import CCStatsService from '../../services/CCStatsService';

export default function useCCStats(dataset, country, regionKey, revision = 0) {
  const generation = useRef(0);
  const [result, setResult] = useState({ key: null, status: 'idle', data: null });
  const key = dataset && regionKey ? `${country}:${dataset.id}:${dataset.class_schema}:${regionKey}:${revision}` : null;
  useEffect(() => {
    if (!key) return;
    const requestId = ++generation.current;
    const controller = new AbortController();
    setResult({ key, status: 'loading', data: null });
    CCStatsService.getCCStatsForRegion(regionKey, dataset, country, controller.signal).then((data) => {
      if (!controller.signal.aborted && generation.current === requestId) setResult({ key, status: 'ready', data });
    }).catch((error) => {
      if (controller.signal.aborted || generation.current !== requestId) return;
      console.error('CC statistics request failed', error);
      setResult({ key, status: 'error', data: null, code: error.response?.status });
    });
    return () => { controller.abort(); generation.current += 1; };
  }, [key, country, dataset, regionKey]);
  return !key ? { status: 'idle', data: null } : result.key === key ? result : { status: 'loading', data: null };
}
